/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsFindOneReportRunsCatalogQueryResponse, AuditReportsFindOneReportRunsCatalogPathParams, AuditReportsFindOneReportRunsCatalog401, AuditReportsFindOneReportRunsCatalog403, AuditReportsFindOneReportRunsCatalog404 } from "../models/AuditReportsFindOneReportRunsCatalog";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsFindOneReportRunsCatalog } from "../axios/auditReportsFindOneReportRunsCatalog";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsFindOneReportRunsCatalogQueryKey = (id: AuditReportsFindOneReportRunsCatalogPathParams["id"]) => ["api-v2", { url: '/audit-reports/v1/report-runs/:id', params: {id:id} }] as const

export type AuditReportsFindOneReportRunsCatalogQueryKey = ReturnType<typeof auditReportsFindOneReportRunsCatalogQueryKey>

export function auditReportsFindOneReportRunsCatalogQueryOptions(id: AuditReportsFindOneReportRunsCatalogPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsFindOneReportRunsCatalogQueryKey(id)
        return queryOptions<AuditReportsFindOneReportRunsCatalogQueryResponse, ResponseErrorConfig<AuditReportsFindOneReportRunsCatalog401 | AuditReportsFindOneReportRunsCatalog403 | AuditReportsFindOneReportRunsCatalog404>, AuditReportsFindOneReportRunsCatalogQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsFindOneReportRunsCatalog(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Poll this after create until job.isFinished. Primary outputs are ready when every artifacts[] entry with role=primary has storageUri. Then GET /report-runs/{id}/artifacts/{kind} for a signed HTTPS URL (do not use gs:// storageUri in browsers). If generation failed, metadata.errorCode is GENERATION_FAILED. Tenant-scoped: other clients get 404.
 * @summary Get a report run by id
 * {@link /audit-reports/v1/report-runs/:id}
 */
export function useAuditReportsFindOneReportRunsCatalog<TData = AuditReportsFindOneReportRunsCatalogQueryResponse, TQueryData = AuditReportsFindOneReportRunsCatalogQueryResponse, TQueryKey extends QueryKey = AuditReportsFindOneReportRunsCatalogQueryKey>(id: AuditReportsFindOneReportRunsCatalogPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsFindOneReportRunsCatalogQueryResponse, ResponseErrorConfig<AuditReportsFindOneReportRunsCatalog401 | AuditReportsFindOneReportRunsCatalog403 | AuditReportsFindOneReportRunsCatalog404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsFindOneReportRunsCatalogQueryKey(id)
         

         const query = useQuery({
          ...auditReportsFindOneReportRunsCatalogQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsFindOneReportRunsCatalog401 | AuditReportsFindOneReportRunsCatalog403 | AuditReportsFindOneReportRunsCatalog404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}